<template>
  <div class="top-nav-bar">
    <!-- 修改密码   -->
    <el-dialog :title="$t('ChangePassword')" :visible.sync="editPwdDialog" width="30%" :modal-append-to-body="false">
      <el-input v-model="newPwd1" :placeholder="$t('PEnterNewPwd')"></el-input>
      <el-input v-model="newPwd2" :placeholder="$t('PleaseEnterThePasswordAgain')"></el-input>
      <div class="warning-color" style="line-height: 2;font-size: 14px;">*{{$t('JHPasswordFormatRequirements')}}</div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="editPwdDialog = false">{{ $t('JHCancel') }}</el-button>
        <el-button type="primary" @click="confirmEditPwd()">{{ $t('JHConfirm') }}</el-button>
      </span>
    </el-dialog>
    <!-- 绑定公众号   -->
    <el-dialog :title="$t('JHBinding') + $t('JHOfficialAccount')" :visible.sync="bindDialog" width="30%" :modal-append-to-body="false">
      <el-input v-model="code" :placeholder="$t('JHPleaseEnter',{0:$t('JHVerificationCode')})"></el-input>
      <span slot="footer" class="dialog-footer">
        <el-button @click="bindDialog = false">{{ $t('JHCancel') }}</el-button>
        <el-button type="primary" @click="confirmBind()">{{ $t('JHConfirm') }}</el-button>
      </span>
    </el-dialog>
    <div class="nav-bar-system-name ">
      <div class="system-icon">
        <img :src="logoUrl" width="100%" />
      </div>
      <div class="system-name">
        {{ $t('JHLoginTips4') }}
      </div>
    </div>
    <div class="nav-menu">
      <div v-for="(item, index) in navList" :key="index" :class="activeNav===index?'nav-item-active nav-item line-height':'nav-item line-height'" @click="lickTo(item, index)">
        {{ item.label }}
        <!--      <div class="border"></div>-->
        <div class="arrow"></div>
      </div>
    </div>
    <div class="user-info">
      <!--      <div class="user-notify">-->
      <!--        <el-badge :value="12" class="item">-->
      <!--          <div class="notify-icon"></div>-->
      <!--        </el-badge>-->
      <!--      </div>-->
      <img class="user-avatar" :src="defaultPicture" />
      <div class="user-dropdown-position">
        <el-dropdown trigger="click" size="medium" @command="dropdownClick" @visible-change="wetherBind">
          <span class="el-dropdown-link line-height">
            {{userInfo?userInfo.agentName:""}}
            <i class="el-icon-arrow-down el-icon--right"></i>
          </span>
          <el-dropdown-menu slot="dropdown">
            <el-dropdown-item :disabled="item.able" v-for="(item, index) in dropdownList" :command="item.value" :key="index">{{ item.label }}</el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>
      </div>
    </div>
  </div>
</template>
<script>
import defaultPicture from "../../../assets/default_picture.png";
import md5 from "md5";
import {USER_PWD} from "../../../../api/localStorageName";

export default {
  name: "topNav",
  data() {
    return {
      logoUrl: "./static/logo.png",
      navList: [
        {
          label: this.$t("JHDistributor"),
          url: "/agent/info",
          base: "/agent/",
        },
        // {
        //   label: "进销存",
        //   url:"/erp/commodityArchives",
        //   base: "/erp/"
        // },
        // {
        //   label: "云支付"
        // },
        // {
        //   label: "吉卡云"
        // },
        // {
        //   label: "报表"
        // },
        // {
        //   label: "知鲜到",
        //   url: "/zxd/merchantList",
        //   base: "/zxd/"
        // }
      ],
      dropdownList: [
        {
          label: this.$t("JHUser") + this.$t("JHInfo"), //"个人信息",
          value: "info",
          index:'1'
        },
        {
          label: this.$t('ChangePassword'), // "修改密码",
          value: "edit-pwd",
          able: false,
          index:'2'
        },
        {
          label: this.$t("JHLogout"), // "退出登录",
          value: "logout",
          index:'3'
        },
        {
          label: this.$t("JHBinding") + this.$t("JHOfficialAccount"), // "绑定公众号",
          value: "bind-public",
          able: false,
          index:'4'
        },
      ],
      activeNav: 0,
      bindDialog: false,
      code: "",
      sign: "", //
      defaultPicture: defaultPicture,
      userId:'',
      editPwdDialog:false,
      newPwd1:'',
      newPwd2:'',
    };
  },
  created() {
    this.userId = localStorage.getItem("userId");
    this.pageInit();
    // this.judgePublic();
  },
  methods: {
    dropdownClick(type) {
      if (type === "logout") {
        this.logout();
      }
      if (type == "bind-public") {
        this.bindPublic();
      }
      if (type == "edit-pwd") {
        this.editPwd();
      }
      if (type == "info") {
        this.$router.push({ path: "/agent/info" });
      }
    },
    wetherBind(val) {
      if (val) {
        console.log(123);
        var openId = localStorage.getItem("openId");
        if (openId) {
          // console.log("已绑定");
          this.dropdownList[3].label = this.$t("JHAlready", {
            0: this.$t("JHBinding"),
          }); // "已绑定";
          this.dropdownList[3].able = true;
        }
      } else {
        this.dropdownList[3].label =
          this.$t("JHBinding") + this.$t("JHOfficialAccount");
        this.dropdownList[3].able = false;
      }
    },
    // 修改密码
    editPwd(){
      this.editPwdDialog = true;
    },

    // 确认修改密码
    confirmEditPwd() {
      console.log(localStorage.getItem("userId"))
      let _this = this;
      if (!this.newPwd1 || !this.newPwd2) {
        this.$message.warning(
          this.$t("JHPleaseEnter", { 0: this.$t("JHPassword") })
        );
        return;
      }
      if(!this.$utils.passwordRegex.test(_this.newPwd1)){
        _this.$message.warning(this.$t('PwdNotGoodPEnter'))
        return
      }
      if(_this.newPwd1 != _this.newPwd2){
        _this.$message.warning(this.$t('JHNewPasswordTips'))
        return
      }
      let oldPwd = localStorage.getItem(USER_PWD);
      this.$http
        .post(this.$path.editPwd, {
          newPwd: md5("agent" + _this.newPwd1),
          oldPwd: md5("agent" + oldPwd),
          agentId: localStorage.getItem("userId")
        })
        .then((res) => {
          if (res && res != "false") {
            localStorage.setItem(USER_PWD, _this.newPwd1);
            this.$message.success(
              this.$t("JHSuccess", { 0: this.$t("JHOperate") })
            );
            this.editPwdDialog = false;
            this.logout();//退出登录
          } else {
            this.$message.error(this.$t("JHFail", { 0: this.$t("JHOperate") }));
          }
        })
        .catch((err) => {
          console.error(err);
          this.$message.error(
            err || this.$t("JHFail", { 0: this.$t("JHOperate") })
          );
        });
    },
    // 绑定公众号
    bindPublic() {
      this.bindDialog = true;
    },
    // 确认绑定公众号
    confirmBind() {
      if (!this.code) {
        // this.$message.warning("请输入验证码");
        this.$message.warning(
          this.$t("JHPleaseEnter", { 0: this.$t("JHVerificationCode") })
        );

        return;
      }
      this.$http
        .post(this.$path.savePush, {
          code: this.code,
          bindSign: this.sign,
          bindId: this.userId,
        })
        .then((res) => {
          if (res && res != "false") {
            this.$message.success(
              this.$t("JHSuccess", { 0: this.$t("JHOperate") })
            );
            // this.judgePublic();
            this.bindDialog = false;
          } else {
            this.$message.error(this.$t("JHFail", { 0: this.$t("JHOperate") }));
          }
        })
        .catch((err) => {
          console.error(err);
          this.$message.error(
            err || this.$t("JHFail", { 0: this.$t("JHOperate") })
          );
        });
    },
    logout() {
      localStorage.clear();
      this.$store.dispatch("logout");
      this.$router.push({ path: "/login/admin" });
    },
    pageInit() {
      const routerUrl = location.href;
      const navList = this.navList;
      navList.map((item, index) => {
        if (item.base && routerUrl.includes(item.base)) {
          this.activeNav = index;
        }
      });
    },
    lickTo(item, index) {
      this.activeNav = index;
      const URL = item ? item.url : null;
      const routerUrl = this.$route.path;
      if (routerUrl === URL) return;
      if (URL) this.$router.push({ path: URL });
    },
  },
  computed: {
    userInfo() {
      return this.$store.state.userInfo;
    },
  },
};
</script>
<style scoped lang="scss">
@import "../../../../theme/index.scss";
.top-nav-bar {
  width: 100%;
  // height: 7vh;
  background: $primary-color;
  display: flex;
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  color: #fff;
  overflow: hidden;
  font-size: 20px;
  z-index: 500;
  .line-height {
    // height: 7vh;
    // line-height: 7vh;
    vertical-align: middle;
  }
  .nav-bar-system-name {
    width: 240px;
    overflow: hidden;
    /*border-right: 1px solid rgba(0, 0, 0, 0.4);*/
    /*margin-right: 40px;*/
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
    /*float: left;*/
    .system-icon {
      width: 48px;
      height: 48px;
      /*float: left;*/
      margin: 6px 10px 0 10px;
    }
    .system-name{
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
    }
  }
  .nav-menu {
    flex: 1;
    display: flex;
    font-size: 18px;
    .nav-item {
      width: 130px;
      text-align: center;
      /*float: left;*/
      position: relative;
      cursor: pointer;
      /*.border {*/
      /*  width: 1px;*/
      /*  background: #fff;*/
      /*  position: absolute;*/
      /*  right: 0;*/
      /*  height: 16px;*/
      /*  top: 22px;*/
      /*}*/
      /*.border:last-child{*/
      /*  width: 0;*/
      /*}*/
    }
    .nav-item-active {
      background: #fff;
      color: $primary-color;
      .arrow {
        width: 0;
        height: 0;
        border: 8px solid #fff;
        border-bottom: 12px solid $primary-color;
        position: absolute;
        bottom: 0;
        left: 55px;
      }
    }
  }

  .user-info {
    display: flex;
    .user-dropdown-position {
      /*float: right;*/
      color: #fff;
      .el-dropdown-link {
        color: #fff;
        font-size: 18px;
        margin-right: 50px;
        cursor: pointer;
      }
    }
    .user-avatar {
      /*float: right;*/
      // border-radius: 50%;
      width: 50px;
      height: 50px;
      margin: 5px 20px 0 0;
    }
    .user-notify {
      /*float: right;*/
      height: 28px;
      /*margin-top: 0.2rem;*/
      margin-right: 60px;
    }
    .notify-icon {
      width: 28px;
      height: 28px;
      border-radius: 50%;
      border: 1px solid #ededec;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/common/navbar/topNav.vue